<div class="row">
  <div class="col-lg-12">
    <div class="ibox-title pt-4">
      <h5 class="sub-title">Projetos</h5>
      <div class="ibox-tools pt-1">
        <button type="button" class="btn btn-primary btn" (click)="novo()">Novo</button>
      </div>
    </div>
    <div class="ibox-content">
      <table id="dtId" datatable [dtOptions]="dtOptions1" [dtTrigger]="dtOptions1.dtTrigger" class="table table-striped" style="width: 100%"></table>
    </div>
  </div>
</div>
<app-loading [loader]="isLoading"></app-loading>